module.exports = __webpack_public_path__ + "img/工业物联网平台.259e7fd8.png";